module.exports = __webpack_public_path__ + "static/media/golf2.e4bb513d.jpg";